import React from "react";
import Question from "./Question";
import { Link } from "gatsby";

function FAQ() {

  return (
    <div className="mt-12 mx-auto w-5/6 max-w-4xl">
      <h3 className="mb-12 text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl sm:leading-10">Frequently Asked Questions</h3>
      <hr className="border-b border-gray-100" />
      <Question 
        question="Why React and TailwindCSS?"
        answer="My preferred front end tech stack was React / Gatsby but I never really liked the CSS part. I finally tried Tailwind and it seemed like a match made in heaven."
      />  
      <Question 
        question="Why did you create these templates?"
        answer="I couldn't really find good examples that combined React with Tailwind. I think this could be because Tailwind is so new and/or it didn't originate from a 
          React component ecosystem. Since I was writing all this code I figured I might as well put it up to see if someone found it valuable."
      />   
      <Question 
        question="Why landing pages?"
        answer="Landing pages are the chocolate flavor of web projects. Most of us need them at some point and so I figured it was a good use case to focus on. I hope to expand soon though!"
      />               
      <Question 
        question="What if I want something custom made?"
        answer={<p>I am happy to look into a custom made project for you! Please send me a <Link className="text-indigo-600 font-medium" to="/contact">message</Link> and we'll talk. :)</p>}
      />                          
    </div>
  )
}

export default FAQ;